<div  class="ui-g ui-fluid form-group master-data customer-cards-info">
  <div class="ui-g loyalty-cluster">
    <div class="ui-g-12" >
      <app-kontable
      #table
      title="Coupon"
      [columns]="[
      {field: 'campaign_name', title: 'campaign.campaign'},
      {field: 'message_instance_name', title: 'campaign.campaignAction'},
      {field: 'coupon_code', title: 'campaign.couponCode'},
      {field: 'barcode', title: 'promotion.barCode'},
      {field: 'cust_name', title: 'campaign.customerName'},
      {field: 'cust_surname', title: 'campaign.customerSurname'},
      {field: 'emission_date_start', title: 'campaign.emissionStartDate', type: 'date', filterType: dateFilter},
      {field: 'emission_date_end', title: 'campaign.emissionEndDate', type: 'date', filterType: dateFilter},
      {field: 'fruition_date_start', title: 'campaign.fruitionStartDate', type: 'date', filterType: dateFilter},
      {field: 'fruition_date_end', title: 'campaign.fruitionEndDate', type: 'date', filterType: dateFilter},
      'card_no'
    ]"
    [titles]="['loyalty.card_no']"
    [source]="couponList"
    [paginationType]="paginationType"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [showReport]="false"
    [showGlobalFilter]="false"
    [additionalRowCommands]="customRow">
      <ng-template #customRow data-testid="customRow" let-row>
        <p-button pTooltip="{{ 'campaign.couponHistory' | translate }}" icon="fa fas fa-eye" styleClass="ui-button-info" (onClick)="viewCouponHistory(row)"></p-button>
        <p-button pTooltip="{{ 'campaign.printCoupon' | translate }}" icon="fa fas fa-print" styleClass="ui-button-info" (onClick)="printCoupon(row, 'P')"></p-button>
        <p-button pTooltip="{{ 'campaign.reserveCoupon' | translate }}" icon="fa fas fa-pencil" styleClass="ui-button-info" (onClick)="reserveCoupon(row)"></p-button>
        <p-button pTooltip="{{ 'campaign.useCoupon' | translate }}" icon="fa fas fa-download" styleClass="ui-button-info" (onClick)="useCoupon(row)"></p-button>
        <p-button pTooltip="{{ 'campaign.undoReserveCoupon' | translate }}" icon="fa fas fa-mail-reply" styleClass="ui-button-info" (onClick)="undoReserveCoupon(row)"></p-button>
        <p-button pTooltip="{{ 'campaign.undoUseCoupon' | translate }}" icon="fa fas fa-mail-reply-all" styleClass="ui-button-info" (onClick)="undoUseCoupon(row)"></p-button>
        <p-button pTooltip="{{ 'common.cancel' | translate }} {{ 'campaign.printCoupon' | translate }}" icon="fa fas fa-ban" styleClass="ui-button-info" (onClick)="printCoupon(row, 'UP')"></p-button>
      </ng-template>
    </app-kontable>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/coupon-manager/coupon-manager.component.html